import { Component, Inject, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { ActionSheetController } from '@ionic/angular';
import { AlertController, NavController } from '@ionic/angular';
import { IonContent } from '@ionic/angular';
import { IonInfiniteScroll } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';


@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.page.html',
  styleUrls: ['./product-list.page.scss'],
})
export class ProductListPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  userId: any;
  productList: any = [];
  category: any = "";
  page_number: number = 1;
  limit = 1000;
  searchParams: String;
  searchResultData: any = [];
  noDataImage: boolean = false;
  locationFlag: any = 0;

  address: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  subCategory: any;
  isLoading: boolean = false;
  productFound: boolean = false;
  pin: any;
  city = localStorage.getItem('city');
  isPromoActiveFlag: any;
  storeDetail: any;
  recommendflag: any;
  first: boolean;
  count: any;
  search: boolean = false;
  resultsAvailable: boolean = false;
  page: any;
  myObj2: any;
  filterO = 1;
  a: any;
  discount: any = "0";
  price: any = "0-10000000";
  filterData: any;
  length: any;
  check: any = 0;
  offset: any = 0;
  //Edit by Sharaddha
  cart: any = [];
  qty: number = 1;
  show: any;
  userAddress: string = ''
  userLatitude: string = ''
  userLongitude: string = ''
  addressDisplay: any;
  googlemap: any;
  isItemAvailable: boolean;
  ipaddress: any;
  merChat: any;
  bannerImg: any;
  middleImgbottom: any;
  metaDescription=localStorage.getItem('metaDescription');
  constructor(public title: Title, private renderer: Renderer2, private meta: Meta, private ngZone: NgZone,@Inject(DOCUMENT) private document: Document,private userService: UserService,private routerActivate: ActivatedRoute, private router: Router, private authService: StoreService, public actionSheetController: ActionSheetController, public alertController: AlertController, private navController: NavController, private toast: ToastService) {

  }

  ngOnInit() {
    this.category=this.routerActivate.snapshot.params.category;
    this.subCategory=this.routerActivate.snapshot.params.subCat;
    if(this.subCategory==0){
      this.subCategory=""
    }
    console.log(this.city)
    if (this.city != null && this.city != '') {
      localStorage.setItem('city', this.city);
    }
    if (this.pin != null && this.pin != '') {
      localStorage.setItem('pin', this.pin);
    }
    // this.storageService.get(AuthConstants.AUTH_USERDATA).then((data) => {
    //   this.userId = data
    // })
    //this.userId = localStorage.getItem('userId');
    this.city = localStorage.getItem('city');
    if (this.city != null) {
      this.locationFlag = 3;
    }
    this.pin = localStorage.getItem('pin')
    if (this.pin != null) {
      this.locationFlag = 2;
    }
    this.searchResultData = ""

    this.listOfProduct()
    this.topBannerImage();
    this.city = localStorage.getItem('city')
    this.middleBannerImage(this.city);
    this.merchantCatList()
    this.pin = localStorage.getItem('pin')
     // Edit By vikash Kumar
  // Location Api display in navbar
    const value=localStorage.getItem('city');
           if (value){
            this.city=value
            // document.getElementById('modal').style.display='none';
          
           } 
  else{
    this.getP()
  }
  this.ionViewWillEnter()
  const canonicalURL = `https://spotyourdeal.com/product-list/${this.category}/${this.subCategory}`;
  const link = this.renderer.createElement('link');
  this.renderer.setAttribute(link, 'rel', 'canonical');
  this.renderer.setAttribute(link, 'href', canonicalURL);
  this.renderer.appendChild(document.head, link);
  const pageTitle = `SpotYourDeal - ${this.category}`;
  this.title.setTitle(pageTitle);
  this.meta.addTags([
     
    // Meta robots
    { name: "robots", content: "index,follow" },
    // OG Tag Facebook
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonicalURL },
    { property: "og:title", content:  pageTitle},
    { property: "og:description", content: this.metaDescription},

   
]);
  }

  ionViewWillEnter(){
    this.listOfProduct()
    }
    listOfProduct() {
      var cart = JSON.parse(localStorage.getItem("cart"))
      this.productList=[]
      this.isLoading = true;
      const promoListobj = {
        cat: this.category,
        subcat: this.subCategory,
        limit: this.limit,
        // userId:this.userId,
        // zip: this.pin,
        city: this.city,
        // islocationMatch: this.locationFlag,
        // lat: "",
        // long: "",
        offset: this.offset,
      }
  
      this.authService.getProduct(promoListobj).subscribe((data: any) => {
        this.isLoading = false;
        if (data.code == 2 && this.page_number == 1) {
          this.noDataImage = true
        } else if (data.code == 3 && this.page_number == 1) {
          this.noDataImage = true
  
        } else {
  
          for (let i = 0; i < data.length; i++) {
  
            this.productFound = true;
            this.count = 0;
            for (let j = 0; j < this.productList.length; j++) {
              if (this.productList[j].articleNumber == (data[i].articleNumber)) {
                this.count++;
              }
            }
            if (this.count == 0) {
              this.productList.push(data[i]);
              var product = cart.filter((element: any)=>element.id==this.productList[i]._id)[0]
              if(product)
              this.productList[i]['qty'] = product.qty
            
  
            }
  
  
  
  
          }
      
          const products = this.productList;
          console.log("product detail API hit1", products)

          // SEO
          let metaDescription = '';
          let keywords="";
          products.forEach((product: any) => {
            metaDescription += `${product.name}, `;
            keywords += `${product.name}, `;
          });
          metaDescription = metaDescription.slice(0, -2);
          this.meta.updateTag({ name: 'keywords', content: keywords });
        
        
          // Update the meta tag description
          this.meta.updateTag({ name: 'description', content: metaDescription });
          localStorage.setItem('metaDescription', metaDescription);
          
          let Imagepath = '';
          products.forEach((product: any) => {
            Imagepath += `${product.Imagepath}, `;
          });
          this.meta.updateTag({ property: 'og:image', content: Imagepath });

          // END SEO
          console.log("dataImage", this.noDataImage)
        }
        if (this.productList.length > 0) {
          this.check = 0;
        } else {
          this.check = 1;
          console.log("hekkkk")
        }
  
      }, (error: any) => {
  
      });
    }
 

  productDetail(productItem: any) {
    let qty = 1;
    // console.log("product item object clickable product", productItem);
    let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, backPageFlag: { cat: this.category, subCat: this.subCategory, city: this.city, backPageFlagInfo: "2" } } };
    this.router.navigate(['/product-detail'], navigationParams);
  }

  ///Added for search product

  fetchCatStoreTerm(peoplename) {
    this.router.navigate(['/search-product']);
  }
  goBack() {
    this.navController.pop();
  }


  // handleAddToCart(productObj) {
  //   let promoListobj = {
  //     productdetails: productObj,
  //     userId: this.userId
  //   }
  //   // this.authService.addCartServices(APIS.addTocart,formdata,true)
  //   this.authService.addToCart(promoListobj)
  //     .subscribe((result: any) => {
  //       //this.messanger.sendMsg(productObj)
  //       this.toast.presentToast("Product added in your cart")
  //     }, (error: any) => {});
  // }

  filter() {
    this.filterO = this.filterO * (-1)
    console.log(this.filterO)
    if (this.filterO == 1) {
      this.a = 10
    } else {
      this.a = 125;
    }
  }

  filterSubmit() {
    let formData = {
      city: this.city,
      cat: this.category,
      subcat: this.subCategory,
      limit: this.limit,
      offset: 0
    }

    if (this.price != "")
      formData['price'] = this.price.split("-");

    if (this.discount != 0)
      formData['discount'] = this.discount;

    this.authService.getProduct(formData).subscribe(res => {
      this.filterData = res;
      this.productList = this.filterData;
      this.length = res.length;
      this.filterO = 1;
      this.a = 20;
      if (this.productList.length > 0) {
        this.check = 0;
      } else {
        this.check = 1;
      }
    })
  }

  notifications() {
    this.router.navigate(['/wishlist'])
  }
  home(){
    this.router.navigate(['/'])
  }

  isModalOpen = false;

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
    this.filterO = this.filterO * (-1)
    console.log(this.filterO)
    if (this.filterO == 1) {
      this.a = 10
    } else {
      this.a = 125;
    }
  }
  isModalOpen1 = false;

setOpen1(isOpen: boolean) {
  this.isModalOpen = isOpen; 
}
// Edit By vikash Kumar
  // Location get Api
  handleAddressChange(address: any) {
    this.userAddress = address.formatted_address;
     this.addressDisplay = this.userAddress.split(',')[0];   
    this.userLatitude = address.geometry.location.lat()
    this.userLongitude = address.geometry.location.lng();
    localStorage.setItem('city', this.addressDisplay);
    this.middleBannerImage(this.addressDisplay);
    document.getElementById('modal-one').style.display='hidden'; 
  }

onClickSegment(event) {
  console.log("event hi",event)
}
getLocation(ev: any) {
  console.log('i m ')
  const val = ev.target.value;
  if (val && val.trim() !== '') {
      this.isItemAvailable = true;
    
      this.authService.addressLookup({value:val}).subscribe((data)=>{
        this.googlemap=data;
        // console.log("ee",data)
        console.log("response google map", this.googlemap)})
     
      } else {
        this.isItemAvailable = false;
      }
      
    }
    
    change(val) {
      const searchbox = document.getElementById('popover');
      console.log(searchbox,'hjh..')
      searchbox.style.display = 'none';
  this.city = val.split(',')[0]; ;
  localStorage.setItem('city', this.city)
  // document.getElementById('trigger-button').style.display='none';
  this.middleBannerImage(this.city)
  location.reload() 
}
getP(){
  console.log("i am hit")
this.authService.getIpAddress().subscribe(res => {

  this.ipaddress = res['ip'];
  console.log("ip")
  this.authService.getGEOLocation(this.ipaddress).subscribe(res => {
console.log(res);
   this.city = res['city'];
   localStorage.setItem('city', this.city)
   // document.getElementById('trigger-button').style.display='none';
   this.middleBannerImage(this.city)
  });
  //console.log(res);

});}
topBannerImage() {
  this.authService.topBannerImg().subscribe((result: any) => {
    console.log("Response banner image", result)
    this.bannerImg = result
    this.merchantCatList()
  }, (error: any) => {
    this.toast.presentToast(error)

  });
}
merchantCatList() {
  this.authService.preDifnedCat().subscribe((result: any) => {
    console.log("Response from merchandied catagories", result)
    this.merChat = result

  }, (error: any) => {
    this.toast.presentToast(error)
  });
}
middleBannerImage(city:any) {
  let that = this;
  const DisObj = {
    city: city
  }
  this.authService.middleBannerImg1(DisObj).subscribe((result: any) => {

    this.ngZone.run(() => {
      console.log("result ", result)
      that.middleImgbottom = result;
      console.log("that.middleImgbottom ", that.middleImgbottom)
    });

  }, (error: any) => {

  });
 
}
handleAddToCarta(productObj) {
  console.log("productObj ", productObj)

  this.cart = []
  if (productObj.qty) {///Added by Parul
    ++productObj.qty
  }
  else {
    productObj['qty'] = 1;
  }
  let cart = localStorage.getItem("cart");
  if (cart) {
    this.cart = JSON.parse(cart);
    console.log("cart ", this.cart)
    let filtered = this.cart.filter(product => product.id == productObj._id)
    console.log("filtered ", filtered)
    if (filtered.length == 0) {
      var pdata = {
        id: productObj._id,
        qty: this.qty
      }
      console.log(pdata)
      this.cart.push(pdata)
      localStorage.setItem('cart', JSON.stringify(this.cart))
      // this.show = 1
    } else {
      console.log(this.show)
      let index = this.cart.indexOf(filtered[0]);
      console.log("index ", index)
      this.cart[index]['qty'] = productObj.qty;//Added by Parul
      // this.cart.splice(index, 1)
      localStorage.setItem('cart', JSON.stringify(this.cart))
      // this.show = null

    }
  } else {
    console.log("item._id ", productObj._id)
    var pdata = {
      id: productObj._id,
      qty: this.qty
    }
    this.cart.push(pdata)
    localStorage.setItem('cart', JSON.stringify(this.cart))
    this.show = 1
  }
  this.userService.cartUpdated.next(true);
}

deleteFromCart(item) {
  if (item.qty > 0) {
    --item.qty;
    this.cart = []
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == item._id)
      let index = this.cart.indexOf(filtered[0])
      this.cart[index]['qty'] = item.qty;
      if (item.qty == 0) {
        this.cart.splice(index, 1)
      }
      localStorage.setItem('cart', JSON.stringify(this.cart))
      this.userService.cartUpdated.next(true);
    }
    // this.loadCartItems();

  }
}
}
